import * as React from 'react';
import { Redirect } from 'react-router-dom';

import { isLoggedIn, isLoggedInChangePassword } from '../services/user.service';
import { merchantLoginRoute } from './routes';

function AuthRequired({ WrappedComponent, partialLogin, ...props }) {
  const loggedIn = partialLogin ? isLoggedInChangePassword() : isLoggedIn();
  if (loggedIn) {
    return <WrappedComponent {...props} />;
  }
  return <Redirect to={merchantLoginRoute} />;
}

export function authRequired(WrappedComponent, props, isPartialAuth = false) {
  return function () {
    return (
      <AuthRequired WrappedComponent={WrappedComponent} partialLogin={isPartialAuth} {...props} />
    );
  };
}
